import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const location = useLocation();
  const userStr = localStorage.getItem('adminUser');

  // 1. If NOT authenticated, redirect to login (preserve attempted route)
  if (!userStr) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 2. Check role authorization
  try {
    const user = JSON.parse(userStr);
    const role = user.role
      ? user.role.charAt(0).toUpperCase() + user.role.slice(1).toLowerCase()
      : 'Teacher';

    if (allowedRoles && !allowedRoles.includes(role)) {
      // User is logged in but not authorized for this route
      return <Navigate to="/dashboard" replace />;
    }
  } catch (error) {
    // Invalid user data - redirect to login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 3. User is authenticated and authorized
  return children;
};

export default ProtectedRoute;

